// src/pages/PasswordChangePage.jsx
import { useState } from "react";
import axios from "axios";
import { Box, Heading, VStack, Input, Button } from "@chakra-ui/react";
import { showSuccess, showError } from "../utils/toastUtils";

export default function PasswordChangePage() {
  const [form, setForm] = useState({ current: "", new: "", confirm: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/change-password`,
        {
          currentPassword: form.current,
          newPassword: form.new,
          confirmPassword: form.confirm,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      showSuccess("Erfolg!", "Passwort erfolgreich geändert.");
    } catch (err) {
      console.log(err.response); // 👈 add here
      showError("Fehler!", "Passwortänderung fehlgeschlagen.");
    }
  };

  return (
    <Box p={8}>
      <Heading size="lg" mb={6}>
        Passwort ändern
      </Heading>
      <VStack spacing={4} align="stretch" maxW="md">
        <Input
          type="password"
          name="current"
          placeholder="Altes Passwort"
          onChange={handleChange}
        />
        <Input
          type="password"
          name="new"
          placeholder="Neues Passwort"
          onChange={handleChange}
        />
        <Input
          type="password"
          name="confirm"
          placeholder="Neues Passwort bestätigen"
          onChange={handleChange}
        />
        <Button colorScheme="blue" onClick={handleSubmit}>
          Passwort speichern
        </Button>
      </VStack>
    </Box>
  );
}